import React from 'react'
import { graphql } from 'gatsby';

import Header from '../components/Header';
import Main from '../components/Main/MasterClass';
import Footer from '../components/Footer';

const MasterClass = (props) => {
    const post = props.data.wordpressPost;
    let date = undefined;
    if (props.location.state !== undefined && props.location.state !== null) {
      date = props.location.state.date;
    }

    return(
        <div>
          <Header />
          <Main data={post} date={date} />
          <Footer />
        </div>
      )
};

export default MasterClass;

export const postQuery = graphql`
    query($id: String!) {
        wordpressPost(id: { eq: $id }) {
            title
            content
            slug
        }
        site {
            siteMetadata {
              title
              description
            }
        }
    }
`